// Import Core Components here

import React, { Component } from "react";
import { observer, inject } from "mobx-react";
import PropTypes from "prop-types";

// Import App depedency here
import {
  Button,
  GridRow,
  GridColumn,
  GridContainer,
  Img,
  Ripple,
  Loader,
} from "arv-reactcomponents";
import { PasswordInput } from "../";
import UserId from "../UserId";

import { gmailInit } from "../utils";
import { fbInit } from "../../../utils";
import staticEndpoints from "../../../api/endPoints/staticEndpoints";
import Analytics from "../../../analytics";
import Event from "../../../analytics/eventFactory";

@inject("LoginStore")
@observer
class LoginSub extends Component {
  constructor(props) {
    super(props);
    this.state = {
      FbLoaded: false,
    };
    this.userId = props.LoginStore.userId;
    this.userIdFields = null;
    this.passwordFields = null;
    this.onLogin = this.onLogin.bind(this);
    this.fbLoaded = this.fbLoaded.bind(this);
    this.showRegisterView = this.showRegisterView.bind(this);
    this.showForgotPasswordView = this.showForgotPasswordView.bind(this);
    this.onFbClick = this.onFbClick.bind(this);
    this.onGmailClick = this.onGmailClick.bind(this);
  }
  componentDidMount() {
    gmailInit(this.onGmailClick);
    fbInit(this.fbLoaded);
    const invalidInput = document.querySelector(".nw-sublogin-form input");
    if (invalidInput) {
      setTimeout(() => {
        invalidInput.focus();
      });
    }
  }
  onLogin(e) {
    e.preventDefault();
    const invalidInput = document.querySelector(
      ".nw-sublogin-form input.is-invalid",
    );
    if (invalidInput) {
      invalidInput.focus();
    }
    if (
      this.passwordFields.state.isPasswordInputValid &&
      this.userIdFields.state.isUserIdValid
    ) {
      const { userId, inputType } = this.userIdFields.state;
      const { password } = this.passwordFields.state;
      Analytics.trackEvent({
        action: Event.action.LOGIN_FILLED,
        category: Event.category.LOGIN,
        label: inputType,
      });
      this.props.LoginStore.loginUserAction(userId, password);
    }
  }
  onFbClick() {
    Analytics.trackEvent({
      action: Event.action.FACEBOOK_LOGIN,
      category: Event.category.LOGIN,
    });
    this.props.LoginStore.fbAction();
  }
  onGmailClick(accessToken, type) {
    Analytics.trackEvent({
      action: Event.action.GMAIL_LOGIN,
      category: Event.category.LOGIN,
    });
    this.props.LoginStore.loginUserSocially(accessToken, type);
  }
  get isFormValid() {
    return this.props.LoginStore.authError ? "" : "nwc-hidden";
  }
  get isShowLoader() {
    return this.props.LoginStore.loader ? "" : "nwc-hidden";
  }
  get isSocialLoader() {
    return this.props.LoginStore.socialLoader ? "" : "nwc-hidden";
  }
  fbLoaded() {
    this.setState({ FbLoaded: true });
  }
  showRegisterView() {
    Analytics.trackEvent({
      action: Event.action.REGISTER_CLICK,
      category: Event.category.LOGIN,
      label: Event.label.getSource("home"),
    });
    this.props.LoginStore.changeView("register");
  }
  showForgotPasswordView() {
    if (this.userIdFields.state.isUserIdValid) {
      const { userId } = this.userIdFields.state;
      this.props.LoginStore.changeView("forgotPassword", userId);
    } else {
      this.props.LoginStore.changeView("forgotPassword");
    }
    Analytics.trackEvent({
      action: Event.action.FORGOT_PASSWORD_CLICK,
      category: Event.category.LOGIN,
    });
  }
  render() {
    return (
      <div className="nw-login-container">
        <div
          className={`
            nw-login-loader
            nw-social-loader
            ${this.isSocialLoader}
          `}
        >
          <Loader className="nw-sloader" />
        </div>
        <div className="nw-login-heading">
          <h1 className="nw-login-title">login</h1>
          <p className="nw-login-sub-title">with</p>
        </div>
        <GridContainer className="nw-social-login">
          <GridRow>
            <GridColumn className="nwc-grid-col-xs nw-slogin-buttons">
              <Button
                className="nw-social-btn nw-gmail"
                id="google-login"
                disabled="true"
              >
                <Img src={staticEndpoints.gmailLogo} alt="google sign-in" />
                <span>GOOGLE</span>
              </Button>
            </GridColumn>
            <GridColumn className="nwc-grid-col-xs nw-slogin-buttons">
              <Button
                className="nw-social-btn nw-fb"
                onClick={this.onFbClick}
                disabled={!this.state.FbLoaded}
              >
                <Img src={staticEndpoints.fbLogo} alt="facebook sign-in" />
                <span>FACEBOOK</span>
              </Button>
            </GridColumn>
          </GridRow>
        </GridContainer>
        <div className="nw-login-divider">
          <span className="nw-login-or">Or</span>
          <div className="nw-divider" />
        </div>
        <form className="nw-form nw-sublogin-form" onSubmit={this.onLogin}>
          <UserId
            className="nw-login-input nw-sublogin-userid"
            placeholder="Enter Your Email-ID or Phone Number"
            name="text"
            value={this.userId}
            ref={values => {
              this.userIdFields = values;
            }}
          />
          <PasswordInput
            className="nw-login-input nw-sublogin-password"
            placeholder="Enter Your Password"
            name="password"
            ref={values => {
              this.passwordFields = values;
            }}
          />
          <Button
            onClick={this.showForgotPasswordView}
            type="button"
            className="nw-login-link nw-sublogin-forgotpwd"
          >
            I forgot my password
          </Button>
          <Ripple className="nwc-ripple-light">
            <Button
              type="submit"
              className="nwc-btn-primary nw-login-btn nw-sublogin-submitbtn"
            >
              LOGIN
              <div className={`nw-login-loader ${this.isShowLoader}`}>
                <Img
                  className="nw-loader"
                  src="//static.nnnow.com/client/assets/images/icon/loader.gif"
                  alt="loader"
                />
              </div>
            </Button>
          </Ripple>
          <span className={`nw-login-error ${this.isFormValid}`}>
            {this.props.LoginStore.authErrorMsg}
          </span>
        </form>
        <div className="nw-login-reg-container">
          <p className="nw-login-reg-text">New user?</p>
          <span>
            <Button
              onClick={this.showRegisterView}
              className="nw-login-reg-button nw-sublogin-registerbtn"
            >
              Register
            </Button>
          </span>
        </div>
      </div>
    );
  }
}
LoginSub.wrappedComponent.propTypes = {
  LoginStore: PropTypes.shape({
    loginUserAction: PropTypes.func.isRequired,
    fbAction: PropTypes.func.isRequired,
    loginUserSocially: PropTypes.func.isRequired,
    authError: PropTypes.bool.isRequired,
    authErrorMsg: PropTypes.string.isRequired,
    changeView: PropTypes.func.isRequired,
    userId: PropTypes.string,
    loader: PropTypes.bool.isRequired,
    socialLoader: PropTypes.bool.isRequired,
  }).isRequired,
};
export default LoginSub;



// WEBPACK FOOTER //
// ./src/component/Login/LoginSub/index.js